import {StorageFileType} from '../../../backend/enums';
import {AttachmentType} from '../../../backend/enums/attachment-type';

export const acceptedTypes = [
  `image/${StorageFileType.JPG}`,
  `image/jpeg`,
  `image/${StorageFileType.PNG}`,
  `image/${StorageFileType.GIF}`,
  `image/${StorageFileType.TIFF}`,
  `application/${StorageFileType.DICOM}`,
  `video/${StorageFileType.MOV}`,
  `video/${StorageFileType.MP4}`,
  `audio/${StorageFileType.MP3}`,
  `audio/${StorageFileType.WAV}`,
  `.${StorageFileType.MOV}`,
  `.${StorageFileType.DOC}`,
  `.${StorageFileType.DOCX}`,
  `.${StorageFileType.TXT}`,
  `.${StorageFileType.XLS}`,
  `.${StorageFileType.XLSX}`,
  `application/${StorageFileType.PDF}`,
  `.${StorageFileType.PDF}`,
  `.${StorageFileType.PPT}`,
  `.${StorageFileType.PPTX}`,
  `.${StorageFileType.CSV}`,
];

const imageTypes = [
  StorageFileType.JPG,
  StorageFileType.PNG,
  StorageFileType.GIF,
  StorageFileType.TIFF,
  StorageFileType.DICOM,
];
const videoTypes = [StorageFileType.MOV, StorageFileType.MP4];
const audioTypes = [StorageFileType.MP3, StorageFileType.WAV];
const documentTypes = [
  StorageFileType.DOC,
  StorageFileType.DOCX,
  StorageFileType.TXT,
  StorageFileType.XLS,
  StorageFileType.XLSX,
  StorageFileType.PDF,
  StorageFileType.PPT,
  StorageFileType.PPTX,
  StorageFileType.CSV,
];

export const getStorageAndAttachmentTypes = (
  fileType: string
): {storageType: StorageFileType; attachmentType: AttachmentType} | null => {
  let storageType = fileType.substring(fileType.indexOf('/') + 1, fileType.length);
  let type = storageType.substring(0, storageType.indexOf('/'));

  // JPEG
  if (storageType === 'jpeg') {
    storageType = StorageFileType.JPG;
  }
  // PNG
  else if (storageType === 'png') {
    storageType = StorageFileType.PNG;
  }
  // GIF
  else if (storageType === 'gif') {
    storageType = StorageFileType.GIF;
  }
  // TIFF
  else if (storageType === 'tiff') {
    storageType = StorageFileType.TIFF;
  }
  // WORD documents (microsoft, google, apple)
  else if (
    storageType === 'vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    storageType === 'msword' ||
    storageType === 'vnd.google-apps.document' ||
    storageType === 'vnd.apple.pages'
  ) {
    storageType = StorageFileType.DOCX;
  }
  // Excel documents (microsoft, google, apple)
  else if (
    storageType === 'vnd.openxmlformats-officedocument.presentationml.presentation' ||
    storageType === 'vnd.ms-powerpoint' ||
    storageType === 'vnd.google-apps.presentation' ||
    storageType === 'vnd.apple.keynote'
  ) {
    storageType = StorageFileType.PPTX;
  }
  // PDF documents (microsoft, google, apple)
  else if (
    storageType === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    storageType === 'vnd.ms-excel' ||
    storageType === 'vnd.google-apps.spreadsheet' ||
    storageType === 'vnd.apple.numbers'
  ) {
    storageType = StorageFileType.XLSX;
  }
  // Plain text files
  else if (storageType === 'plain') {
    storageType = StorageFileType.TXT;
  }

  if (!Object.values(StorageFileType).includes(storageType as StorageFileType)) {
    console.error(`Storage type ${storageType} not supported. Original file type: ${fileType}.`);
    return null;
  }

  type = imageTypes.includes(storageType as StorageFileType)
    ? 'image'
    : videoTypes.includes(storageType as StorageFileType)
      ? 'video'
      : audioTypes.includes(storageType as StorageFileType)
        ? 'audio'
        : documentTypes.includes(storageType as StorageFileType)
          ? 'document'
          : '';

  if (type === '') {
    console.error(`Attachment type ${type} not supported`);
    return null;
  }

  return {
    storageType: storageType as StorageFileType,
    attachmentType: type as AttachmentType,
  };
};
